<script>
import FormFile from "./FormFile";

export default {
  name: "AppFormPicture",
  extends: FormFile,
  props: {
    acceptedFiles: {
      type: String,
      required: false,
      default: "image/png,image/jpeg,image/jpg",
    },
    resizeQuality: {
      type: Number,
      required: false,
      default: 0.8,
    },
    resizeWidth: {
      type: Number,
      required: false,
      default: null,
    },
    resizeHeight: {
      type: Number,
      required: false,
      default: null,
    },
  },
  computed: {
    dropzoneOptions() {
      return Object.assign({}, this.getDropzoneOptions(), {
        resizeWidth: this.resizeWidth,
        resizeHeight: this.resizeHeight,
        resizeQuality: this.resizeQuality,
      });
    },
  },
};
</script>
